import React, { useEffect } from "react";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //   useEffect(() => {
  //     if (window.fbq) {
  //       window.fbq("track", "Lead");
  //     }
  //   }, []);

  useEffect(() => {
    // Проверяем, что пользователь попал сюда после отправки формы
    if (!location.state?.formSubmitted) {
      navigate("/"); // Если нет – отправляем на главную
      return;
    }

    // ✅ Отправляем событие в Facebook Pixel
    if (window.fbq) {
      window.fbq("track", "SubmitApplication", {
        firstName: location.state.firstName,
        lastName: location.state.lastName,
        email: location.state.email,
        countryCode: location.state.countryCode,
        phone: location.state.phone,
      });
    }
  }, [location, navigate]);

  return (
    <Box sx={{ background: "black" }}>
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
            background: "#bba8e0",
          }}
        >
          <Typography variant="h4" fontWeight="bold" color="#000" gutterBottom>
            Поздравляю!
          </Typography>
          <Typography variant="body1" color="textPrimary" paragraph>
            Вы сделали важный шаг к переменам и новому уровню жизни.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            В ближайшее время я свяжусь с вами, чтобы подтвердить детали вашей
            сессии. А пока настройтесь на результат: впереди вас ждет глубокая
            работа, которая поможет увидеть новые возможности, обрести ясность и
            сделать шаги к желаемым целям.
          </Typography>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="textPrimary"
            paragraph
          >
            До скорой встречи на сессии!
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="#cc7472">
            Действуйте сейчас — ваше будущее начинается сегодня!
          </Typography>
          <Typography
            variant="body2"
            display="block"
            color="textSecondary"
            mt={2}
          >
            С Ув. Владислав Кронин.
          </Typography>
          <Button
            variant="contained"
            sx={{
              background: "linear-gradient(to right,  #d47ca2, #cc7472)",
              color: "white",
              mt: 3,
              width: "100%",
              borderRadius: "50px",
            }}
            size="large"
            onClick={() => navigate("/")}
          >
            Вернуться на главную
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default ThankYou;
